import { ElementType, ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import { OrevePopup, OrevePopupTitle, OrevePopupContent } from 'components/popup/OrevePopup.tsx';
import { OreveButton } from 'components/button/OreveButton.tsx';
import CheckIcon from 'assets/svg/check-icon.svg';
import ErrorIcon from 'assets/svg/error-icon.svg';
import {Loader} from "components/Loader.tsx"

export interface BackendFeedbackPopupProps {
    open: boolean;
    onClose: () => void;
    onContinue?: (() => void) | null;
    success: boolean;
    successTitle?: string;
    successContent: ReactNode;
    errorTitle?: string;
    errorContent: ReactNode;
    buttonText?: string;
    buttonIcon?: ElementType | null;
    isLoading?: boolean;
    dataCy?: string;
}

export const BackendFeedbackPopup = ({
    open,
    onClose,
    onContinue,
    success,
    successTitle = 'Opération réussie',
    successContent,
    errorTitle = 'Une erreur est survenue',
    errorContent,
    buttonText = 'Fermer',
    buttonIcon,
    isLoading,
    dataCy = "",
}: BackendFeedbackPopupProps) => {
    const title = success ? successTitle : errorTitle;
    const content = success ? successContent : errorContent;
    const icon = success ? CheckIcon : ErrorIcon;
    const color = success ? 'black' : 'error';

    return (
        <OrevePopup open={open} handleClose={isLoading ? undefined : onClose}>
            {isLoading ? (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        minHeight: '200px',
                        width: '100%',
                    }}
                >
                    <Loader />
                </Box>
            ) : (
                <Box data-cy={`${dataCy}`}>
                    <OrevePopupTitle>
                        <img src={icon} alt={success ? 'success' : 'error'} />
                        <Typography
                            variant="headlineSmall"
                            component="div"
                            color={color}
                            data-cy={`${dataCy}--title`}
                        >
                            {title}
                        </Typography>
                    </OrevePopupTitle>
                    <OrevePopupContent>
                        <Typography
                            variant="bodyLarge"
                            component="div"
                            whiteSpace="pre-line"
                            data-cy={`${dataCy}--content`}
                        >
                            {content}
                        </Typography>
                        <OreveButton
                            sx={{ mt: '2.25rem' }}
                            icon={buttonIcon}
                            value={buttonText}
                            variant="contained"
                            color="primary"
                            onClick={onClose}
                            data-ct={`${dataCy}--validation`}
                        />
                        {onContinue && (
                            <OreveButton
                                value={"Continuer"}
                                variant="outlined"
                                color="primary"
                                onClick={onContinue}
                                sx={{ mt: '2.25rem', ml: '1rem' }}
                                data-cy={`${dataCy}--continue`}
                            />
                        )}
                    </OrevePopupContent>
                </Box>)}
        </OrevePopup>
    );
};